import { signal } from '@angular/core';

import { SeasonCalendarPeriodDto } from '@app/data/dtos/manage-vacations/manage-vacations.dto';
import {
  MotCreateProposalDto,
  MotManageVacationsProposalsDto
} from '@app/data/dtos/manage-vacations/mot/mot-manage-vacations.dto';
import { SlotProbability } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import {
  MotFactoryProposal,
  MotSeasonProposal,
  MotVacationsProposal
} from '@app/entities/models/manage-vacations/mot-manage-vacations.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

import { mapObservations } from '../manage-vacations.mapper';

export const mapMotVacationsProposals: MapFromFn<MotManageVacationsProposalsDto, MotVacationsProposal> = (value) =>
  Builder.forModel(MotVacationsProposal)
    .winter(mapMotSeasonProposal(value ? value.winter_proposals.map(mapMotFactoryPeriods) : []))
    .summer(mapMotSeasonProposal(value ? value.summer_proposals.map(mapMotFactoryPeriods) : []))
    .titleMessage(value ? value.vacation_proposal_message : '')
    .observations(value?.employee_observations ? mapObservations(value.employee_observations) : undefined)
    .build();

export const mapMotSeasonProposal: MapFromFn<MotFactoryProposal[], MotSeasonProposal> = (value) =>
  Builder.forModel(MotSeasonProposal).proposals(signal(value)).build();

export const mapMotProposalDto: MapFromFn<MotFactoryProposal, SeasonCalendarPeriodDto> = (value) =>
  Builder.forDto<SeasonCalendarPeriodDto>()
    .order(value.order ?? 1)
    .start_date(value.startDate)
    .end_date(value.endDate)
    .description(value.description ?? '')
    .num_of_days(value.numDays ?? 0)
    .probability(value.probability ?? SlotProbability.LOW)
    .build();

export const mapMotCreateProposalDto = (
  proposals: MotVacationsProposal,
  storedProposals: MotFactoryProposal[],
  isSummerSeason: boolean
) => {
  const createProposal: MotCreateProposalDto = {
    winter_proposals: [],
    summer_proposals: [],
    employee_observations: ''
  };

  if (isSummerSeason) {
    createProposal.winter_proposals = proposals?.winter.proposals().map(mapMotProposalDto) || [];
    createProposal.summer_proposals = storedProposals.map(mapMotProposalDto);
  } else {
    createProposal.winter_proposals = storedProposals.map(mapMotProposalDto);
    createProposal.summer_proposals = proposals?.summer.proposals().map(mapMotProposalDto) || [];
  }

  createProposal.employee_observations = proposals?.observations?.content || '';

  return createProposal;
};

export const mapMotFactoryPeriods: MapFromFn<SeasonCalendarPeriodDto, MotFactoryProposal> = (value) =>
  Builder.forModel(MotFactoryProposal)
    .id(value.id)
    .startDate(value.start_date)
    .endDate(value.end_date)
    .description(value.description)
    .probability(value.probability)
    .numDays(value.num_of_days)
    .order(value.order ?? 1)
    .build();
